function requestStorageDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/request-storage/request-storage-dialog.html?$$REVISION$$'
  }
}

export { requestStorageDialog }
